import invariant from 'invariant';

import type { AppConfig } from '#/config/types/AppConfig';
import { isNotEmpty } from '#/utils/functional/poly';

type Args = {
  appConfig: AppConfig;
};

export function getSearchAlgoliaDefaultConfig({ appConfig }: Args): {
  appId: string;
  apiKey: string;
} {
  const { appId } = appConfig.algolia;
  const apiKey = appConfig.algolia.searchApiKey;

  invariant(isNotEmpty(appId), 'appId cannot be empty');
  invariant(isNotEmpty(apiKey), 'apiKey cannot be empty');

  return { appId, apiKey };
}

export function getSearchAlgoliaConfigWithApiKey({
  apiKey,
  appConfig,
}: {
  apiKey: string;
  appConfig: AppConfig;
}) {
  return { ...getSearchAlgoliaDefaultConfig({ appConfig }), apiKey };
}
